module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sendMoney/_add-account-detail/add-account-detail.component.css
// module id = ./src/app/sendMoney/_add-account-detail/add-account-detail.component.css
// module chunks = main